import { schema } from 'normalizr';
import { SCHEMA_TYPE_SERVICE_KEY } from '../constants/schemaTypes';

export const serviceKeysSchema = new schema.Entity(SCHEMA_TYPE_SERVICE_KEY, {});
